namespace GeniuzPOS.Inventory {
    export namespace IcStockApproveDisassembleService {
        export const baseUrl = 'Inventory/IcStockApproveDisassemble';

        export declare function Create(request: Serenity.SaveRequest<IcStockApproveDisassembleRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<IcStockApproveDisassembleRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetNextNumber(request: GetNextNumberRequest, onSuccess?: (response: GetNextNumberResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<IcStockApproveDisassembleRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<IcStockApproveDisassembleRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Inventory/IcStockApproveDisassemble/Create",
            Update = "Inventory/IcStockApproveDisassemble/Update",
            Delete = "Inventory/IcStockApproveDisassemble/Delete",
            GetNextNumber = "Inventory/IcStockApproveDisassemble/GetNextNumber",
            Retrieve = "Inventory/IcStockApproveDisassemble/Retrieve",
            List = "Inventory/IcStockApproveDisassemble/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'GetNextNumber', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>IcStockApproveDisassembleService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
